export const userUpdateAuth = (val) => {
    return {
        type: "USER_UPDATE_AUTH",
        value: val
    };
}

export const userUpdateUUID = (val) => {
    return {
        type: "USER_UPDATE_UUID",
        value: val
    };
}

export const userUpdateName = (val) => {
    return {
        type: "USER_UPDATE_NAME",
        value: val
    };
}

export const userUpdateEmail = (val) => {
    return {
        type: "USER_UPDATE_EMAIL",
        value: val
    };
}

export const userUpdateRole = (val) => {
    return {
        type: "USER_UPDATE_ROLE",
        value: val
    };
}

export const userUpdateNew = (val) => {
    return {
        type: "USER_UPDATE_NEW",
        value: val
    }
}

export const userUpdateRequestedPassword = (val) => {
    return {
        type: "USER_UPDATE_REQUESTEDPASSWORD",
        value: val
    }
}

export const userUpdateOrgID = (val) => {
    return {
        type: "USER_UPDATE_ORGID",
        value: val
    }
}

export const userUpdateUserDepartments = (val) => {
    return {
        type: "USER_UPDATE_USERDEPARTMENTS",
        value: val
    }
}

export const userUpdateSARequest = (val) => {
    return {
        type: "USER_UPDATE_SAREQUEST",
        value: val
    }
}

export const userUpdateProfiles = (val) => {
    return {
        type: "USER_UPDATE_PROFILES",
        value: val
    }
}

